import { render, staticRenderFns } from "./RatingGraph.vue?vue&type=template&id=47bfd07a&scoped=true&"
import script from "./RatingGraph.vue?vue&type=script&lang=js&"
export * from "./RatingGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bfd07a",
  null
  
)

export default component.exports